import React from 'react';
import PropTypes from 'prop-types'
import AssociatesHeaderSortLink from './AssociatesHeaderSortLink';
import HrbTranslate from '../../../components/language/HrbTranslate';

const AssociatesSortHeader = ({ sortKey, isReversed, onSortChanged, renderLinks }) => {

    return (
        <div className='associate-sort columns'>
            <div className='column is-10 is-offset-1 columns px-1 my-0 py-1 level'>
                <div className='column is-3 pl-0 level-item'>
                    {renderLinks ?
                        <AssociatesHeaderSortLink sortKey='name' currentSortKey={sortKey} isReversed={isReversed} onClick={onSortChanged} renderLink={renderLinks}>
                            <HrbTranslate text='AssociatesPage.SortHeaders.Name' />
                        </AssociatesHeaderSortLink>
                        :
                        <HrbTranslate text='AssociatesPage.SortHeaders.Name' className='header-sort-link' />
                    }
                </div>
                <div className='column is-4 pl-0 level-item'>
                    {renderLinks ?
                        <AssociatesHeaderSortLink sortKey='role' currentSortKey={sortKey} isReversed={isReversed} onClick={onSortChanged} renderLink={renderLinks}>
                            <HrbTranslate text='AssociatesPage.SortHeaders.Role' />
                        </AssociatesHeaderSortLink>
                        :
                        <HrbTranslate text='AssociatesPage.SortHeaders.Role' className='header-sort-link' />
                    }
                </div>
                <div className='column is-4 pl-0 level-item'>
                    {renderLinks ?
                        <AssociatesHeaderSortLink sortKey='auto-assignment' currentSortKey={sortKey} isReversed={isReversed} onClick={onSortChanged} renderLink={renderLinks}>
                            <HrbTranslate text='AssociatesPage.SortHeaders.AutoAssign' />
                        </AssociatesHeaderSortLink>
                        :
                        <HrbTranslate text='AssociatesPage.SortHeaders.AutoAssign' className='header-sort-link' />
                    }
                </div>
                <div className='column is-1 pl-0 level-item'>
                    <HrbTranslate text='AssociatesPage.SortHeaders.Manage' className='header-sort-link' />
                </div>
            </div>
        </div>
    );
}

AssociatesSortHeader.propTypes = {
    sortKey: PropTypes.string,
    isReversed: PropTypes.bool,
    onSortChanged: PropTypes.func.isRequired,
    renderLinks: PropTypes.bool
}

export default AssociatesSortHeader